import * as React from 'react';
import { VendorViewModel, TradeViewModel } from '@models/Vendor';
import { TradeZipsContainer } from '../trade-zips/_components/trade-zips.container';

export interface TradeExceptionsComponentProperties {
  readonly vendorVM: VendorViewModel;
  readonly currentTrade: TradeViewModel;
}

export class TradeExceptionsComponent extends React.Component<TradeExceptionsComponentProperties> {
  render() {
    return (
      <div>
        <TradeZipsContainer
          vendorVM={this.props.vendorVM}
          currentTrade={this.props.currentTrade}
          isExclusion={true}
          keyVal={`vendor-zip-exclusions`}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/vendor/_components/vendor-trade-maintenance/_components/trade-exceptions.component.tsx